import { render, staticRenderFns } from "./IconTicket.vue?vue&type=template&id=a98d179a&scoped=true&"
import script from "./IconTicket.vue?vue&type=script&lang=js&"
export * from "./IconTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d179a",
  null
  
)

export default component.exports